import CollapsePanel from "molecules/collapse-panel/collapse-panel";
import React from "react";
import { IconSizes } from "atoms/constants/icon-sizes";
import NotebookRecord from "models/view-models/notebook-record";
import NotebookItem from "./notebook-list-item";

const BASE_CLASS_NAME = "c-notebook-sidebar";

interface NotebookListSectionProps {
    notebooks: NotebookRecord[];
    buttonAriaText: string;
    panelTop: React.ReactNode;
    collapse: boolean;
    openNotebookIds: number[];
    getNotebookClassModifier: (notebookId: number) => string;
    onSectionOpen: () => void;
    onSectionClose: () => void;
    onNotebookTitleClick: (
        id: number,
        isOpen: boolean,
        shouldExpand: boolean
    ) => void;
    onNotebookExpand: (id: number, isOpen: boolean) => void;
    onNotebookClose: (id: number) => void;
    isSharedSection?: boolean;
    isSharedPagesNotebook: (notebook: NotebookRecord) => boolean;
}

const NotebookListSection = ({
    notebooks,
    buttonAriaText,
    panelTop,
    collapse,
    openNotebookIds,
    getNotebookClassModifier,
    onSectionOpen,
    onSectionClose,
    onNotebookTitleClick,
    onNotebookExpand,
    onNotebookClose,
    isSharedSection = false,
    isSharedPagesNotebook,
}: NotebookListSectionProps) => {
    return (
        <div className={`${BASE_CLASS_NAME}__section`}>
            <CollapsePanel
                buttonAriaText={buttonAriaText}
                collapse={collapse}
                iconSize={IconSizes.Base}
                panelTop={panelTop}
                onOpen={onSectionOpen}
                onClose={onSectionClose}>
                {notebooks.map((notebook) => {
                    const notebookId = Number(notebook.id);
                    const isOpen = openNotebookIds.includes(notebookId);
                    const hasNoPages = notebook?.pages?.length === 0;
                    const shouldExpand = !(isSharedSection && hasNoPages);

                    return (
                        <NotebookItem
                            key={notebook.id}
                            notebook={notebook}
                            notebookId={notebookId}
                            isOpen={isOpen}
                            hasNoPages={hasNoPages}
                            shouldExpand={shouldExpand}
                            isSharedSection={isSharedSection}
                            isSharedPagesNotebook={isSharedPagesNotebook}
                            getNotebookClassModifier={getNotebookClassModifier}
                            onNotebookTitleClick={onNotebookTitleClick}
                            onNotebookExpand={onNotebookExpand}
                            onNotebookClose={onNotebookClose}
                        />
                    );
                })}
            </CollapsePanel>
        </div>
    );
};

export default NotebookListSection;
